import { createClient } from '@base44/sdk';

// Get the app ID from environment or use the default from .env.local
const APP_ID = import.meta.env.VITE_BASE44_APP_ID || '696fd9219da7e89e380b558c';

// Create and export the Base44 client instance
export const base44 = createClient({
  appId: APP_ID,
  options: {
    onError: (error) => {
      console.error('Base44 error:', error);
    }
  }
});

// Export types for TypeScript
export type Base44Node = {
  id: string;
  x: number;
  y: number;
  text: string;
  timeEstimate: string;
  type: 'task' | 'note' | 'milestone' | 'text' | 'rectangle' | 'circle' | 'diamond';
  parentId?: string | null;
  children?: string[];
  width?: number;
  height?: number;
  created_date?: string;
  updated_date?: string;
};

export type Base44Connection = {
  id: string;
  fromId: string;
  toId: string;
  created_date?: string;
  updated_date?: string;
};
